const API = process.env.REACT_APP_API_URL || '/api';

/**
 * Submits enrollment form data to the PHP/MySQL backend.
 * @param {{ name: string, phone: string, email: string, source: string }} formData
 * @returns {Promise<void>} resolves on success, throws on error
 */
export async function submitEnrollment(formData) {
  const res = await fetch(`${API}/enroll.php`, {
    method : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body   : JSON.stringify(formData),
  });
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.error || 'Submission failed. Please try again.');
  return json;
}
